import { Module, ActionTree, MutationTree, GetterTree } from 'vuex'
import { Message, MessageType } from '@/interfaces/app/Message'
import { AppState } from '@/types/store/app'
import { RootState } from '@/types/store'

const testMessages = [
  {
    uid: '1',
    message: 'Info',
    type: MessageType.Info,
  },
  {
    uid: '2',
    message: 'Success',
    type: MessageType.Success,
  },
  {
    uid: '3',
    message: 'Warning',
    type: MessageType.Warning,
  },
  {
    uid: '4',
    message: 'Error',
    type: MessageType.Error,
  },
]

const mutations: MutationTree<AppState> = {
  setSidebar(state, payload: boolean) {
    state.sidebar = payload
  },
  setMessages(state, payload: Message[]) {
    state.messages = payload
  },
  addMessage(state, payload: Message) {
    state.messages.push(payload)
  },
  clearMessages(state) {
    state.messages = []
  },
  setLoading(state, payload: boolean) {
    state.loading = payload
  },
}

const actions: ActionTree<AppState, RootState> = {
  clearMessage({ state, commit }, messageUid: string) {
    const messages = state.messages.filter(m => m.uid !== messageUid)
    commit('setMessages', messages)
  },
  addMessage({ state, commit }, message: Message) {
    commit('setMessages', [...state.messages, message])
  },
  addMessages({ state, commit }, messages: Message[]) {
    commit('setMessages', [...state.messages, ...messages])
  },
  addTempMessage(
    { dispatch },
    { message, timeout }: { message: Message; timeout?: number }
  ) {
    dispatch('addMessage', message)
    const delay = timeout || 2000
    setTimeout(() => {
      dispatch('clearMessage', message.uid)
    }, delay)
  },
  addTempMessages(
    { dispatch },
    { messages, timeout }: { messages: Message[]; timeout?: number }
  ) {
    dispatch('addMessages', messages)
    const delay = timeout || 2000
    setTimeout(() => {
      for (const message of messages) {
        dispatch('clearMessage', message.uid)
      }
    }, delay)
  },
}

const getters: GetterTree<AppState, RootState> = {
  sidebar: state => state.sidebar,
  messages: state => state.messages,
  loading: state => state.loading,
}

export const appModule: Module<AppState, RootState> = {
  namespaced: true,
  state: {
    sidebar: true,
    messages: [],
    loading: false,
  },
  mutations,
  actions,
  getters,
}

export default appModule
